const context = {
  breakpoints: ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl'],
  hidden: {},
};

context.breakpoints.forEach((breakpoint) => (context.hidden[breakpoint] = 'none'));

export default context;
